export default {
	sec_01: {
		title: {
			one: '다양한 ',
			two: '결제를',
			three: '빠르게 연동하는',
			four: '편리한 API',
		},
		btn: {
			two: 'Learn more',
		},
	},
};
